import { ApplicationType } from '../../../contracts/applications'

export const applicationType: ApplicationType = 'OPEN_OPPORTUNITIES'
